// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.growth.listing.RentalManagerGrowthGetCompsForListingWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerGrowthGetCompsForListingWebApiHandler_getComps,
  RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { GetCompsForListingResponseWebDto, ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';

interface GetCompsParams {
  listingAlias: ListingAlias;
}

export type RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_Options = UseQueryOptions<
  GetCompsForListingResponseWebDto,
  unknown,
  GetCompsForListingResponseWebDto,
  readonly [string, GetCompsParams]
>;

const RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_GetKey = (getParams: GetCompsParams) =>
  [RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_Path, getParams] as const;

export const RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_queryOptions = (
  getParams: GetCompsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_GetKey(getParams),
    queryFn: () => RentalManagerGrowthGetCompsForListingWebApiHandler_getComps(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get comps (geo + floorplans + similar floorplans) for a listing
 */
export const useRentalManagerGrowthGetCompsForListingWebApiHandler_getComps = (
  getParams: GetCompsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerGrowthGetCompsForListingWebApiHandler_getComps.getKey =
  RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_GetKey;
